export function LoadingFallback(): React.ReactNode {
  return (
    <div
      className="flex min-h-[60vh] items-center justify-center"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="font-display text-sm uppercase tracking-[0.3em] text-mute">Lade…</span>
    </div>
  );
}
